<template>
	<div>
		<firstsceen :imgobj='banner'>

		</firstsceen>

		<div ref="countref">
			<Adword slotheight="666">
				<div class="flexcenter">

					<div :style="{backgroundImage: 'url('+aboutimg+') ' }"
						style="background-repeat:no-repeat; background-position:right top;padding: 28px 33px 0px 0px;">
						<div class="aboutimage1" style=" text-align: left;rgba(38,62,139,0.7)">
							<img class="aboutimage1" src="../../static/我们拥有.png">
							<div class="abouttextview"
								style="color: white;">
								<div class="abouttext2" style="font-weight: bold;margin-bottom:60px ;">
									我们拥有
								</div>
								<div class="flexspacebetween alignitemscenter">
									<div>
										<div class="abouttext2" style="font-weight: bold;">
											<number :animationPaused="customcountshow" ref="number1" :from="0" :to="15"
												:format="theFormat" :duration="2" :delay="0" easing="Power1.easeOut" />
											项
										</div>
										<div class="aboutsubtext2" style="color: #FFFFFF;margin-top: 5px;opacity: 0.5;">
											核心专利</div>
									</div>
									<div style="background-color: #EAEAEA;width: 1px;height: 60px;"> </div>
									<div>
										<div class="abouttext2" style="font-weight: bold; ">
											<number :animationPaused="customcountshow" ref="number2" :from="0" :to="30"
												:format="theFormat" :duration="2" :delay="0" easing="Power1.easeOut" />
											项
										</div>
										<div style="color: #FFFFFF;margin-top: 5px;opacity: 0.5;">
											软件著作权证书</div>
									</div>
									<div style="background-color: #EAEAEA;width: 1px;height: 60px;"> </div>
									<div>
										<div class="abouttext2" style="font-weight: bold; ">
											<number :animationPaused="customcountshow" ref="number3" :from="0" :to="30"
												:format="theFormat" :duration="2" :delay="0" easing="Power1.easeOut" />
											+
										</div>
										<div style="color: #FFFFFF;margin-top: 5px;opacity: 0.5;">
											合作伙伴</div>
									</div>
									<div style="background-color: #EAEAEA;width: 1px;height: 60px;"> </div>
									<div>
										<div class="abouttext2" style="font-weight: bold; ">
											<number :animationPaused="customcountshow" ref="number4" :from="0"
												:to="2000" :format="theFormat" :duration="2" :delay="0"
												easing="Power1.easeOut" />+
										</div>
										<div style="color: #FFFFFF;margin-top: 5px;opacity: 0.5;">
											深度客户</div>
									</div>
								</div>
							</div>

						</div>

					</div>

					<div style="position:relative;">
						<div v-if="customcountshow" class="abouttext1" style="margin-left:60px; "></div>
						<transition name="adfadex5">
							<div v-if="!customcountshow" class="abouttext1" style="margin-left:60px; margin-top: 50px;  ">

								<!-- 新闻内容 文字-->
								<div
									style="text-indent: 1cm;text-align: left;line-height: 21px;color: #666666;font-size: 14px;font-weight: 400;">
									浙江星链数据科技有限公司（以下简称“星链”）是中国鞋业首家C2M数字化技术服务商（C2M，即用户需求驱动柔性供应链），致力于构建数字时尚产业互联网新生态。
								</div>
								<div style="height:  20px;"></div>
								<div
									style="text-indent: 1cm;text-align: left;line-height: 21px;color: #666666;font-size: 14px;font-weight: 400;">
									星链通过网络协同与用户需求的数据驱动，运用互联网、AI大数据和人工智能等技术，链接鞋业上下游产业链，为鞋行业提供大规模个性化智能定制、小批量、多批次、快生产、云工厂的C2M数字化解决方案和柔性供应链服务。
									星链与华为进行联合创新，成立了“创新实验室”，基于华为云盘古大模型开发了3D扫描技术、AI时尚趋势数据挖掘系统、数字化订货交易系统和柔性智能制造数控系统，可为鞋产业提供基于数据驱动的C2M数字化全链路服务，包括“数字研发、数字工厂、数字零售”，助力鞋行业从过去“以产定销、同质化、高库存、重资产”的传统模式升级为C2M数字化模式。
								</div>
								<div style="height:  20px;"></div>
								<div
									style="text-indent: 1cm;text-align: left;line-height: 21px;color: #666666;font-size: 14px;font-weight: 400;">
									星链C2M数字化业务已涵盖鞋类多元化服务，包括新流量平台、行业领导品牌和跨境业务，为品牌客户、设计师、主播达人、MCN机构、时尚买手等提供从趋势设计、选款试销、预售订货，到订单管理、报价生产、交付结算的SaaS技术服务和C2M柔性供应链服务。星链C2M通过云工厂的柔性供应链能力，可帮助客户实现产品“个性化、小批量、多批次、快生产”，其客户涵盖美国ROCKPORT（乐步）、 PUMA（彪马）、SKECHERS（斯凯奇）等全球知名品牌，以及奥康等国内鞋业领导品牌。
								</div>
								<!-- 新闻内容end -->
							</div>
						</transition>

						<div style="margin-left:540px;  bottom:205px;  position :absolute; ">
							<img v-if="isShowNavAD" style="width:40.89px;" src="../../static/关于我们方块2.png" />

						</div>

						<div
							style="margin-left:60px;  bottom:69px;  position :absolute; font-size: 98px;font-weight: bold;color: #333333;letter-spacing: 10px;opacity: 0.05;">
							我们是谁？</div>
						<div
							style="margin-left:60px;  bottom:0px; position :absolute; font-size: 98px;font-weight: bold;color: #333333;letter-spacing: 10px;opacity: 0.02;">
							我们是谁？</div>
					</div>

				</div>
			</Adword>

		</div>
		</Adword>
		<div  v-if="isShowNavAD"  ref="img1ref">
			<Adword style="color: white;" :backimg="img1" viewheight="500" title="我们为社会带来什么">
				<div class="container flexspacebetween" style="width: 65%;">
					<transition name="adfade">
						<img v-if="img1show1" style="width: 122px;height: 260px;" src="../../static/为客户ico.png" />
					</transition>
					<transition name="adfade">
						<img v-if="img1show2" style="width: 122px;height: 260px;" src="../../static/关注每ico.png" />
					</transition>
					<transition name="adfade">
						<img v-if="img1show3" style="width: 122px;height: 260px;" src="../../static/用科技降ico.png" />
					</transition>
					<transition name="adfade">
						<img v-if="img1show4" style="width: 122px;height: 260px;" src="../../static/承担更多ico.png" />
					</transition>

				</div>
			</Adword>
		</div>
		<Adword title="企业价值观" viewheight="600">
			<div class="flexcenter" style="padding: 10px 50px 10px 50px;">
				<div @mouseenter="swimg2(0)"
					style="position: relative;width: 273px;height:373px; overflow: hidden; margin-bottom:30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div class="cc" style="width: 273px;height:373px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;">
								诚<br>信
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[0]?'imgscale':'']" style="height: 373px;z-index: 1; "
						src="../../static/诚信.png">
				</div>
				<div style="width: 20px;height: 1px;"></div>

				<div @mouseenter="swimg2(1)"
					style="position: relative;width: 273px;height:373px;; overflow: hidden;margin-bottom:30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div class="cc" style="width: 273px;height:373px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;">
								创<br>新

							</div>
						</div>

					</div>
					<img :class="[swimgbool2[1]?'imgscale':'']" style="height: 373px;z-index: 1;"
						src="../../static/创新.png">
				</div>

				<div style="width: 20px;height: 1px;"></div>
				<div @mouseenter="swimg2(2)"
					style="position: relative;width: 273px;height:373px;; overflow: hidden;margin-bottom:30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div class="cc" style="width: 273px;height:373px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;text-align: center;">

								高<br>效
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[2]?'imgscale':'']" style="height: 373px;z-index: 1;"
						src="../../static/高效.png">
				</div>
				<div style="width: 20px;height: 1px;"></div>

				<div @mouseenter="swimg2(3)"
					style="position: relative;width: 273px;height:373px; overflow: hidden;margin-bottom:30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div class="cc" style="width: 273px;height:373px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;">

								责<br>任
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[3]?'imgscale':'']" style="height: 373px;z-index: 1;"
						src="../../static/责任.png">
				</div>


			</div>

		</Adword>

		<div ref="img2ref">
			<Adword style="color: white;" :backimg="img2" viewheight="600" title="企业历程">
				<div
					style="margin-left:auto;margin-right:auto; width:75%; text-align: left;position:relative; height:450px">
					<transition name="adfade2">
						<div v-if="img2show1" style="display: flex;margin-top: 320px;position :absolute;left:0%">
							<img style="height: 130px;margin-top: -15px;" src="../../static/企业历程ico.png" />
							<div>
								<div
									style="letter-spacing: 3px;font-weight: bold;font-size: 14px;color: #FFFFFF;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									2019年
								</div>
								<div
									style="font-weight: 400;margin-top:6px; color: #D0D2D4;line-height: 18px;letter-spacing: 2px;font-size: 12px;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									首家C2M特许专卖店开业 </br>
									亮相上海CHIC展 </br>
									男鞋鞋楦智能匹配算法发布 </br>
									全资成立深圳数智时尚有限公司 </br>
								</div>
							</div>
						</div>
					</transition>

					<transition name="adfade2">
						<div v-if="img2show2" style="display: flex;margin-top:220px;position :absolute;left:25%">
							<img style="height: 130px;margin-top: -15px;" src="../../static/企业历程ico.png" />
							<div>
								<div
									style="letter-spacing: 3px;font-weight: bold;font-size: 14px;color: #FFFFFF;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									2020年
								</div>
								<div
									style="font-weight: 400;margin-top:6px; color: #D0D2D4;line-height: 18px;letter-spacing: 2px;font-size: 12px;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									第五代移动式AI智能脚型扫描仪发布</br>
									A轮融资战略发布会</br>
									女鞋智能算法发布</br>
									“千店智能升级”项目启动</br>
								</div>
							</div>
						</div>
					</transition>

					<transition name="adfade2">
						<div v-if="img2show3" style="display: flex;margin-top: 120px;position :absolute;left:50%">
							<img style="height: 130px;margin-top: -15px;" src="../../static/企业历程ico.png" />
							<div>
								<div
									style="letter-spacing: 3px;font-weight: bold;font-size: 14px;color: #FFFFFF;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									2021年
								</div>
								<div
									style="font-weight: 400;margin-top:6px; color: #D0D2D4;line-height: 18px;letter-spacing: 2px;font-size: 12px;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									完成A+轮融资</br>
									80家C2M智能门店落地</br>
									荣获FNAA“年度鞋履产业创新奖”</br>
									联合华为开展六大创新项目</br>
								</div>
							</div>
						</div>
					</transition>

					<transition name="adfade2">
						<div v-if="img2show4" style="display: flex;margin-top: 20px;position :absolute;left:75%">
							<img style="height: 130px;margin-top: -15px;" src="../../static/企业历程ico.png" />
							<div>
								<div
									style="letter-spacing: 3px;font-weight: bold;font-size: 14px;color: #FFFFFF;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									2022年
								</div>
								<div
									style="font-weight: 400;margin-top:6px; color: #D0D2D4;line-height: 18px;letter-spacing: 2px;font-size: 12px;text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);">
									蝉联FNAA“年度鞋履产业创新奖”</br>
									控股成立浙江星知科技有限公司 </br>

								</div>
							</div>
						</div>
					</transition>


				</div>
			</Adword>
		</div>

	</div>
</template>

<script>
	import firstsceen from '../../components/firstsceenimagebase.vue'
	import Adbigwordbutton from '../../components/adBigWordButton.vue'
	import Adword from '../../components/adword.vue'
	export default {
		name: 'index',
		components: {
			firstsceen,
			Adbigwordbutton,
			Adword
		},
		data() {
			return {
				banner: require('../../static/数据驱动.png'),
				img1: require('../../static/我们为社会带来了什么.png'),
				img2: require('../../static/企业历程.png'),
				aboutimg: require('../../static/关于我们方块.png'),

				customcountshow: true,
				counttop: 9999,
				scrolltop: 0,

				swimgbool2: [false, false, false, false],

				img1top: 9999,
				img1show1: false,
				img1show2: false,
				img1show3: false,
				img1show4: false,

				img2top: 9999,
				img2show1: false,
				img2show2: false,
				img2show3: false,
				img2show4: false,
				isShowNavAD: false,
			}
		},
		mounted() {
			if (window.innerWidth < 1000) {
				this.isShowNavAD = false
			} else {
				this.isShowNavAD = true
			}

			var _this = this
			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件

			setTimeout(() => {
				_this.counttop = this.$refs.countref.offsetTop
				_this.img1top = this.$refs.img1ref.offsetTop
				_this.img2top = this.$refs.img2ref.offsetTop
			}, 200);


		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop

				// 数字
				if (this.customcountshow) {
					if (this.vscrolltop > this.counttop - 100) {
						this.customcountshow = false;
						this.playAnimation();
					}
				}

				//显示1
				if (!this.img1show1) {
					if (this.vscrolltop > this.img1top - 30) {
						_this.img1show1 = true;

						setTimeout(() => {
							_this.img1show2 = true
						}, 100);
						setTimeout(() => {
							_this.img1show3 = true
						}, 200);
						setTimeout(() => {
							_this.img1show4 = true
						}, 300);
					}
				}
				//显示2
				if (!this.img2show1) {
					if (this.vscrolltop > this.img2top - 100) {
						_this.img2show1 = true;

						setTimeout(() => {
							_this.img2show2 = true
						}, 200);
						setTimeout(() => {
							_this.img2show3 = true
						}, 400);
						setTimeout(() => {
							_this.img2show4 = true
						}, 800);
					}
				}


			},
			theFormat(number) {
				return number.toFixed(0);
			},



			playAnimation() {
				this.$refs.number1.play()
				this.$refs.number2.play()
				this.$refs.number3.play()
				this.$refs.number4.play()
			},
			swimg2: function(index) {
				for (var i = 0; i < 6; i++) {
					if (index == i) {
						if (!this.swimgbool2[index]) {
							this.$set(this.swimgbool2, index, true)
						}
					} else {
						this.$set(this.swimgbool2, i, false)
					}
				}

			},


		},

	}
</script>

<style>
	.adsmalltitleview {
		padding: 30px 38px 30px 38px;

	}

	.adsmalltitle {
		font-size: 28px;
		letter-spacing: 5px;
	}

	@media (max-width: 999px) {
		.aboutimage1 {
			width: 100%;
			height: 100%;
		}

		.abouttext1 {
			width: 70%;
		}

		.abouttext2 {
			font-size: 18px;
			letter-spacing: 3px;
		}

		.aboutsubtext2 {
			font-size: 8px;
		}

		.abouttextview {
			color: white;
			margin-top: -180px;
			padding: 0px 10px 10px 10px;
		}
	}

	@media (min-width: 1000px) {
		.aboutimage1 {
			width: 831px;
			height: 666px;
		}

		.abouttext1 {
			width: 545px;
		}

		.abouttext2 {
			font-size: 36px;
			letter-spacing: 7px;
		}

		.aboutsubtext2 {
			font-size: 12px;
		}

		.abouttextview {
			margin-top: -280px;padding: 0px 63px 63px 63px;
		}
	}
</style>
